import { OwlOptions } from 'ngx-owl-carousel-o';

export enum CommonEnums {
  accountHolderName = 'account_holder_name',
  accountNumber = 'account_holder_number',
  routing_number = 'routing_number',
  bank_name = 'bank_Name',
  Mobile_number = 'Mobile_number',
  Country_Name = 'Country_Name',
  USD = 'USD',
  usd = 'usd',
  userData = 'userData',
  ssn_number = 'ssn_number',
  city = 'city',
  address = 'Street_address',
  pic_code = 'pin_code',
  state_name = 'state_Name',
  ip = '49.36.185.253',
  CreditCard = 'credit card',
  Account = 'account',
  NFT = 'NFTs',
  BANK = 'bank',
  defaultTitle = 'TopFan - The Best Platform for Creators',
  defaultDescription = 'TopFan provides creators with their own personal branded website and app, with all their monetization offerings in a single place, so they can finally own and leverage comprehensive data about their fans. Creators paywall solution with content subscriptions, merchandise, newsletters, livestreams, experiences, paid direct messages, tips and build a more personal relationship with their best fans.',
  creatorsTitle = 'TopFan Creators',
  creatorsDescription = 'Discover and interact with different creators on TopFan',
  keywords = 'creator paywall platform, monetization platform, fan engagement, white labeled, apps, premium subscriptions, merchandise, newsletters, livestreams, personal experiences, paid direct messages, tips',
  noPostFoundMsg = 'No Matching Posts Found',
  REMOVE_COLLAB_CONFIRMATION = 'Are you sure you want to remove the collaboration?',
  REMOVE_COLLABORATION = 'Remove Collaboration',
  VIP_OFFERS = 'VIP Offers',
  DISPLAY_MY_VIP_OFFERS = 'Display My VIP Offers',
  ACTIVE_OFFERS = ' Active Offers',
  INACTIVE_OFFERS = 'Inactive Offers',
  ACTIVE = 'Active',
  INACTIVE = 'Inactive',
  ADD_NEW_OFFER = 'Add new Offer',
  OFFER_TITLE = 'Offer Title',
  CODE_TYPE = 'Code Type',
  ISSUED = 'Issued',
  LEFT = 'Left',
  LOCK_OPTIONS = 'Lock Options',
  ACTION = 'Action',
  MARK_AS_INACTIVE = 'Mark As Inactive',
  MARK_AS_ACTIVE = 'Mark As Active',
  INACTIVATE = 'Disable',
  ACTIVATE = 'Activate',
  OFFER = 'Offer',
  OFFERS = 'Offers',
  CANCEL = 'Cancel',
  courseNotStartedYetMsg = 'This course has not been published yet.',
  EVENT_CALENDAR = 'Events',
  EVENT_TICKETING = 'Event Ticketing',
  EVENT_AND_TICKETING = 'Events & Ticketing',
  DISPLAY_MY_EVENTS = 'Display My Events',
  BUTTON_LABEL = 'Button Label',
  DISPLAY_MY_EVENT_CALENDAR = 'Display My Event Calendar',
  UNLOCK_NFT_STEPS = 'Follow These Steps to Unlock via NFT',
  NFT_STEPS_DESCRIPTION = '1. Use a Chrome Desktop Computer Browser<br>2. Download and Install the MetaMask Chrome Plugin <a href="https://metamask.io" target="_blank" class="highlight">https://metamask.io</a><br>3. Login into your Wallet and choose the chain that your NFT is in (e.g.Polygon)<br>4. Go to Edit Preferences > Connect my NFT Wallet',
  SYNC_DATA_FROM_BANDSINTOWN = 'IMPORT EVENTS FROM BANDSINTOWN',
  ADD_EVENT = 'Add Event',
  DELETE_EVENT_MSG = 'Are you sure you want to delete this event?',
  YES = 'Yes',
  NO = 'No',
  ACTIVE_KEY = 'active',
  IN_ACTIVE_KEY = 'inactive',
  OK = 'Ok',
  ADD = 'Add',
  MONTH = 'Month',
  WATCH_AGAIN = 'Watch Again',
  GUEST = 'guest',
  PAYMENT_METHOD = 'Payment Method',
  AUDIO = 'audio',
  VIDEO = 'video',
  IMAGE = 'image',
  INFINITE = 'Unlimited',
  DELETE_SUBSCRIPTION = 'Delete subscription Plan',
  SYNC_IN_PROGRESS = 'IMPORT IN PROGRESS...',
  RE_SYNC_EVENT = 'Bandsintown Import Settings',
  LAST_SYNCED = 'Last Imported on: ',
  SUBSCRIBERS = 'Subscribers',
  DELETE_CC_DETAILS = 'Delete credit card Details',
  CONFIRM_DELETE_CC = 'Are you sure you want to delete credit card details?',
  DELETE_AND_REPLACE = 'Delete & Replace',
  ACCEPT = 'Accept',
  DECLINE = 'Decline',
  REMOVE = 'Remove',
  DETAILS = 'Details',
  SURE_DELETE_SUBSCRIPTION = 'Are you sure you want to delete this subscription?',
  WARN_DELETE_SUBSCRIPTION = 'If you have active subscribers, they will be notified that you have ended the plan and will immediately loose benefits. You may need to manually issue refunds to fans.',
  DELETE_VIP_OFFER = 'Delete VIP Offer',
  DELETE_DISCOUNT_CODE = 'Delete Discount Code',
  CONFIRM_VIP_OFFER_MSG = 'Are you sure you want to delete this VIP Offer?',
  CONFIRM_DISCOUNT_OFFER_MSG = 'Are you sure you want to delete this Discount Code?',
  WARN_UPDATE_SUBSCRIPTION_MSG = 'Your active subscribers of this plan will be notified by email of the changes.',
  WARN_UPDATE_SUBSCRIPTION_HEADER_TITLE = 'Notify Subscribers of Plan Changes',
  DELETE_WELCOME_MESSAGE = 'Delete Welcome Message',
  DELET_WELCOME_MESSAGE_TEXT =  'Are you sure you want to delete this welcome message?',
  DISCOUNT_CODES = 'Discount Codes',
  DISCOUNT_CODE = 'Discount Code',
  NEW_DISCOUNT_CODE = 'New Discount Code',
  ACTIVE_CODES = 'Active Codes',
  INACTIVE_CODES = 'Inactive Codes',
  EXP_DATE = 'Exp Date',
  USED_BY = 'USED BY',
  LINK_IN_BIO = 'Link In Bio',
  LINK_IN_BIO_LABEL = 'Your Personal Link',
  ADD_EXTERNAL_ACTION = 'Add an External Action Button',
  SAVE_ACTION = 'Save Actions',
  EDIT_EXTERNAL_ACTION = 'Edit External Actions',
  COURSE_NOT_AVAILABLE = 'This course is already full, you can enroll once we have more slots available.'
}

export const SEO_TITLE_DESC = {
  about: {
    title: 'What makes TopFan the best paywall and monetization platform for Independent Creators and Interest Groups?',
    desc: `Creators can sell premium subscriptions, newsletters, livestreams, experiences, merchandise, paid direct messages in one place, under their own branded website and app, while owning the data about their fans.`,
    keywords: 'creator monetization platform, creator engagement platform, creator paywall site, creator subscription platform, creator data ownership'
  },
  terms: {
    title: 'Terms of Service - TopFan',
    desc: `TopFan Terms and Conditions regarding acceptable content, creator and fan behavior and other policies.  TopFan provides a family friendly and brand safe creator platform that does not allow sexually oriented content.`,
    keywords: 'acceptable content, creator content paywall provider, creator monetization policies'
  },
  contact: {
    title: 'Contact Us - TopFan',
    desc: `Contact Customer Support.`,
    keywords: 'creator monetization platform, creator engagement platform, creator paywall site, creator subscription platform, creator data ownership'
  },
  privacy: {
    title: 'Privacy Policy - TopFan',
    desc: `Privacy Policy explaining the rights of creators and fans who use TopFan.`,
    keywords: 'privacy policy, topfan, creators, fans, paywall platform, data ownership, creator monetization, direct to fan platform'
  },
  help: {
    title: 'TopFan Customer Support Help Center and FAQs',
    desc: `The TopFan Help Center offers Frequently Asked Questions (FAQs) about the TopFan.com platform, help articles and ability to contact customer support.`,
    keywords: 'creator customer support on TopFan, fan customer support on TopFan, how to monetize with fans'
  },
  advertise: {
    title: 'Advertise on TopFan',
    desc: `TopFan offers customized advertising solutions for brands allowing you to reach new and diverse audiences in an authentic and highly targeted manner.`,
    keywords: 'creator advertising, creator pay per conversion, creator advertising to fans, best creator advertising, creator marketing platform, brand advertising with creators'
  },
  pricing: {
    title: 'Pricing - TopFan',
    desc: `TopFan is 100% free for creators to directly engage with their best fans`,
    keywords: 'free monetization platform for creators, creator monetization site, paywall for content, patreon alternative, onlyfans alternative, fanfix alternative, substack alternative, cameo alternative, kajabi alternative, brand army alternative'
  },
  login: {
    title: 'Login Page',
    desc: `Login in your TopFan.com Account or Reset your Password`,
    keywords: 'creator monetization platform, creator engagement platform, creator paywall site, creator subscription platform, creator data ownership'
  },
  signup: {
    title: 'Create an Account',
    desc: `Join the fasting growing community for content creators and their fans`,
    keywords: 'creator monetization platform, creator engagement platform, creator paywall site, creator subscription platform, creator data ownership'
  },
  forgotPassword: {
    title: 'Forgot Password',
    desc: `Enter the email address you registered with, and we will send you a Verification Code to confirm your email address is valid.`,
    keywords: 'creator monetization platform, creator engagement platform, creator paywall site, creator subscription platform, creator data ownership'
  },
  comparison:{
    title: 'TopFan vs Patreon vs Substack vs Passes vs FanFix',
    desc: `TopFan is the leading platform used by creators to connect and monetize with their fans around the world.  TopFan superior technology and business model, and data ownership policies allows creators to finally take back control and build a sustainable business for themselves.`,
    keywords: 'patreon alternative, onlyfans alternative, fanfix alternative, substack alternative, cameo alternative, kajabi alternative, brand army alternative, patreon competitor, onlyfans competitor, fanfix competitor, substack competitor, cameo competitor, kajabi competitor, brand army competitor'
  },
  creators: {
    title: 'White-Labeled Creator Monetization and Paywall Platform',
    desc: 'TopFan is the complete creator monetization platform, providing creators with powerful tools to grow, engage, and monetize your fanbase. Own your data, deepen fan community connections, and build sustainable revenue with subscriptions.',
    keywords: 'creators, paywall, monetization, platform, subscriptions, premium content, membership, white-labeled'
  },
  portfolio:{
    desc: `Explore a diverse portfolio showcasing the finest in music and movies. From captivating soundtracks to cinematic masterpieces, discover creative works that blend art, storytelling, and innovation. Whether you're a music enthusiast or a film lover, this portfolio offers a glimpse into the world of entertainment through a unique lens`
  },
  advertisement: {
    title: 'Advertise on TopFan - Reach Your Audience with Creators',
    desc: 'Promote your brand on TopFan, the complete creator monetization platform. Connect with engaged fan communities, increase visibility, and grow your audience by advertising alongside top creators.',
    keywords: 'Advertise on TopFan, Creator Advertising Platform, Brand Promotion for Creators, Advertise with Influencers, Direct-to-Fan Advertising, Creator Audience Advertising, Fan Engagement Advertising, Promote Brand on Creator Platforms, Creator Sponsorship Opportunities, Digital Advertising with Creators, Audience Targeting on Creator Platforms, Advertiser Tools for Fan Communities'
}
};

export const CAROUSEL_OPTION: OwlOptions = {
  loop: false,
  startPosition: 2,
  autoWidth: true,
  mouseDrag: false,
  touchDrag: false,
  center: true,
  pullDrag: true,
  dots: false,
  lazyLoad: true,
  margin: 0,
  navSpeed: 700,
  navText: [
    "<em class='icon-drop-down'></em>",
    "<em class='icon-drop-down'></em>"
  ],
  responsive: {
    0: {
      items: 1
    },
    400: {
      items: 1
    },
    740: {
      items: 1
    },
    940: {
      items: 1
    }
  },
  nav: true
};

export enum DateEnums {
  MMDDYYY = 'MM-DD-YYYY'
}

export const booleanEnums = {
  TRUE: true,
  FALSE: false
};

export const US_STATES = [
  {
    name: 'Alabama',
    abbreviation: 'AL'
  },
  {
    name: 'Alaska',
    abbreviation: 'AK'
  },
  {
    name: 'American Samoa',
    abbreviation: 'AS'
  },
  {
    name: 'Arizona',
    abbreviation: 'AZ'
  },
  {
    name: 'Arkansas',
    abbreviation: 'AR'
  },
  {
    name: 'California',
    abbreviation: 'CA'
  },
  {
    name: 'Colorado',
    abbreviation: 'CO'
  },
  {
    name: 'Connecticut',
    abbreviation: 'CT'
  },
  {
    name: 'Delaware',
    abbreviation: 'DE'
  },
  {
    name: 'District Of Columbia',
    abbreviation: 'DC'
  },
  {
    name: 'Federated States Of Micronesia',
    abbreviation: 'FM'
  },
  {
    name: 'Florida',
    abbreviation: 'FL'
  },
  {
    name: 'Georgia',
    abbreviation: 'GA'
  },
  {
    name: 'Guam',
    abbreviation: 'GU'
  },
  {
    name: 'Hawaii',
    abbreviation: 'HI'
  },
  {
    name: 'Idaho',
    abbreviation: 'ID'
  },
  {
    name: 'Illinois',
    abbreviation: 'IL'
  },
  {
    name: 'Indiana',
    abbreviation: 'IN'
  },
  {
    name: 'Iowa',
    abbreviation: 'IA'
  },
  {
    name: 'Kansas',
    abbreviation: 'KS'
  },
  {
    name: 'Kentucky',
    abbreviation: 'KY'
  },
  {
    name: 'Louisiana',
    abbreviation: 'LA'
  },
  {
    name: 'Maine',
    abbreviation: 'ME'
  },
  {
    name: 'Marshall Islands',
    abbreviation: 'MH'
  },
  {
    name: 'Maryland',
    abbreviation: 'MD'
  },
  {
    name: 'Massachusetts',
    abbreviation: 'MA'
  },
  {
    name: 'Michigan',
    abbreviation: 'MI'
  },
  {
    name: 'Minnesota',
    abbreviation: 'MN'
  },
  {
    name: 'Mississippi',
    abbreviation: 'MS'
  },
  {
    name: 'Missouri',
    abbreviation: 'MO'
  },
  {
    name: 'Montana',
    abbreviation: 'MT'
  },
  {
    name: 'Nebraska',
    abbreviation: 'NE'
  },
  {
    name: 'Nevada',
    abbreviation: 'NV'
  },
  {
    name: 'New Hampshire',
    abbreviation: 'NH'
  },
  {
    name: 'New Jersey',
    abbreviation: 'NJ'
  },
  {
    name: 'New Mexico',
    abbreviation: 'NM'
  },
  {
    name: 'New York',
    abbreviation: 'NY'
  },
  {
    name: 'North Carolina',
    abbreviation: 'NC'
  },
  {
    name: 'North Dakota',
    abbreviation: 'ND'
  },
  {
    name: 'Northern Mariana Islands',
    abbreviation: 'MP'
  },
  {
    name: 'Ohio',
    abbreviation: 'OH'
  },
  {
    name: 'Oklahoma',
    abbreviation: 'OK'
  },
  {
    name: 'Oregon',
    abbreviation: 'OR'
  },
  {
    name: 'Palau',
    abbreviation: 'PW'
  },
  {
    name: 'Pennsylvania',
    abbreviation: 'PA'
  },
  {
    name: 'Puerto Rico',
    abbreviation: 'PR'
  },
  {
    name: 'Rhode Island',
    abbreviation: 'RI'
  },
  {
    name: 'South Carolina',
    abbreviation: 'SC'
  },
  {
    name: 'South Dakota',
    abbreviation: 'SD'
  },
  {
    name: 'Tennessee',
    abbreviation: 'TN'
  },
  {
    name: 'Texas',
    abbreviation: 'TX'
  },
  {
    name: 'Utah',
    abbreviation: 'UT'
  },
  {
    name: 'Vermont',
    abbreviation: 'VT'
  },
  {
    name: 'Virgin Islands',
    abbreviation: 'VI'
  },
  {
    name: 'Virginia',
    abbreviation: 'VA'
  },
  {
    name: 'Washington',
    abbreviation: 'WA'
  },
  {
    name: 'West Virginia',
    abbreviation: 'WV'
  },
  {
    name: 'Wisconsin',
    abbreviation: 'WI'
  },
  {
    name: 'Wyoming',
    abbreviation: 'WY'
  }
];

export type Direction = 'left' | 'right';

export enum offerCodeTypes {
  UNIQUE_CODES = 'Unique Codes',
  GENERAL_CODE = 'General Code'
}
export enum optionDirection {
  HORIZONTAL = 'horizontal',
  VERTICAL = 'vertical'
}

export enum appRoutingUrl {
  LOYALTY_HISTORY = '/wallet/loyalty-history',
  COURSE_DETAIL = '/dashboard/course-detail',
  POST_FORUM = '/post/forum',
  TYPE_POST = '/post/',
  VIP_OFFERS_LIST = '/monetize/vip-offers',
  DASHBOARD_PAYMENT = 'dashboard/make-payment',
  SUBSCRIBE_VIP_OFFER_LIST = '/dashboard/vip-offer',
  DASHBOARD_POST_FOLLOW = '/dashboard/posts/follow',
  DASHBOARD_EVENT_LISTING = '/dashboard/event-listing',
  COURSES_EXPERIENCE_DETAILS_PAGE = 'dashboard/merchandise-details/[userName]&[userId]/[pk]/[sk]/store',
  NFT_MERCHANDISE_DETAILS_PAGE = 'dashboard/merchandise-detail/[userName]/[id]/store/[type]',
  POST = '/post',
  SHARE = '/share/',
  DOWNLOADABLE = '/monetize/downloadable',
  DOWNLOADABLEADD = '/monetize/downloadable/add',
  DOWNLOADABLEEDIT = '/monetize/downloadable/edit-downloadable/[downloadableId]',
  INSIGHT = '/insights',
  NOTIFICATION_FOLLOWING = '/edit-preference/following-seeMore',
  PREFERENCE_NOTIFICATION = '/edit-preference/notifications',
  BECOME_A_CREATOR = 'edit-preference/become-a-creator',
  DASHBOARD_ACTIVITY = '/dashboard/activity',
  DASHBOARD_POSTS = '/dashboard/posts/',
  PREFERENCE_PRIVACY = '/edit-preference/privacy',
  WALLET_FULFILLMENT = '/wallet/my-fulfillment-requests',
  MESSAGES = 'messages',
  HELP_FAQ = '/help-faq',
  WALLET_REFUND_REQUESTS = '/wallet/refund-requests',
  RESOURCES = '/resources',
  RESOURCES_ANNOUNCEMENTS = '/resources/announcements',
  RESOURCES_TIPS_TUTORIALS = '/resources/tips-tutorials',
  RESOURCES_RESOURCE_DETAILS = '/resources/resource-details',
  NOT_FOUND = '/not-found',
  RESOURCES_SERVICE_PROVIDERS = '/resources/service-providers',
  RESOURCES_SERVICE_PROVIDER_DETAILS = '/resources/service-provider-details',
  CREATOR_SUPPORT = '/resources/creator-support',
  DISCOUNT_CODES = '/monetize/discount-codes',
  LINK_IN_BIO = '/monetize/link-in-bio',
  TOPIC_TAGS = '/edit-preference/topic-tags'
}

export enum ErrorCodes {
  RESTRICTED_CONTENT = 420
}

export enum ErrorTypes {
  LIVESTREAM_LOCKED = 'LIVESTREAM_LOCKED',
  KICKED_OUT = 'KICKED_OUT'
}